<div class="row">
    <div class="col-md-12">
        <h2>Exam Related Issue</h2>
    </div>

    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Total</b></h4>
                <p>{{totalcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b> Pending</b></h4>
                <p>{{pendingcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Resolved</b></h4>
                <p>{{resolvedcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Rejected</b></h4>
                <p>{{rejectedcount}}</p>
            </div>
        </div>
    </div>
</div>
<hr>